document.addEventListener("DOMContentLoaded", () => {
  const triggers = document.querySelectorAll(".menu-trigger");
  const megaMenu = document.getElementById("megaMenuContent");
  const kitsContent = document.getElementById("kitsContent");
  const linhasContent = document.getElementById("linhasContent");

  let activeMenu = null;
  let menuLocked = false;

  function hideAllMenus() {
    kitsContent.style.display = "none";
    linhasContent.style.display = "none";
    megaMenu.classList.remove("open");
    activeMenu = null;
  }

  function showMenu(type) {
    hideAllMenus();
    if (type === "kits") {
      kitsContent.style.display = "flex";
    } else if (type === "linhas") {
      linhasContent.style.display = "flex";
    }
    megaMenu.classList.add("open");
    activeMenu = type;
  }

  triggers.forEach((trigger) => {
    const type = trigger.dataset.menu;

    trigger.addEventListener("mouseenter", () => {
      if (!menuLocked) showMenu(type);
    });

    trigger.addEventListener("click", (e) => {
      // ⚠️ Só usa preventDefault se for <a>
      if (e.target.tagName.toLowerCase() === "span") {
        e.preventDefault();
      }

      if (menuLocked && activeMenu === type) {
        hideAllMenus();
        menuLocked = false;
      } else {
        showMenu(type);
        menuLocked = true;
      }
    });
  });

  megaMenu.addEventListener("mouseleave", () => {
    if (!menuLocked) hideAllMenus();
  });

  document.addEventListener("click", (e) => {
    const isInside =
      e.target.closest(".menu-trigger") || e.target.closest("#megaMenuContent");
    if (!isInside) {
      hideAllMenus();
      menuLocked = false;
    }
  });

});
